export default {"src":"/_next/static/media/ecommerceLogo2.5c9d57aa.svg","height":36,"width":127,"blurWidth":0,"blurHeight":0};